export default {
  en: {
    helpers_count: {
      one: 'helper',
      other: 'helpers',
    },
    snack: {
      generic_error_msg: 'Something went wrong',
      check_success: 'Help successfully added',
      uncheck_success: 'Help successfully removed',
    },
  },
};
